const toggleSearchForm = ( ( document ) => {
	const _toggleForm = () => {
		const openBtn = document.querySelector( '[rel="open-search-box"]' );
		const closeBtn = document.querySelector( '[rel="close-search-box"]' );
		const formWrapper = document.querySelector( '[rel="search-form"]' );
		const searchInput = document.querySelector(
			'input.dgwt-wcas-search-input'
		);
		openBtn.addEventListener( 'click', () => {
			formWrapper.classList.add( 'is-active' );
			searchInput.focus();
		} );
		closeBtn.addEventListener( 'click', () => {
			formWrapper.classList.remove( 'is-active' );
		} );
	};
	const init = () => {
		_toggleForm();
	};

	return {
		init,
	};
} )( document );

export default toggleSearchForm;
